import { useSelector } from 'react-redux';

import * as appSelectors from 'store/modules/app/selectors';

export default function useNotificationCounts() {
  const counts = useSelector(appSelectors.getNotificationCounts);

  return counts;
}
